




























import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import { gsap } from 'gsap'

enum PopOutAlign {
    left = 'left',
    right = 'right',
}

@Component
export default class PopOut extends Vue {
    @Prop({ default: PopOutAlign.right }) readonly align!: PopOutAlign
    @Prop({ default: '60%' }) readonly width!: string
    @Prop({ type: Boolean, required: true }) readonly value!: boolean
    @Ref() outer: HTMLDivElement
    @Ref() inner: HTMLDivElement

    animateShow(element: HTMLDivElement, onComplete: () => void) {
        gsap.set(this.outer, {
            opacity: 0,
        })

        gsap.set(this.inner, {
            [this.align]: '-100%',
        })

        gsap.to(this.outer, .4, {
            opacity: 1,
            ease: 'back.out',
        })

        gsap.to(this.inner, .4, {
            [this.align]: '0%',
            onComplete,
        })
    }

    animateHide(element: HTMLDivElement, onComplete: () => void) {
        gsap.to(this.inner, .4, {
            [this.align]: '-100%',
        })

        gsap.to(this.outer, .4, {
            opacity: 0,
            ease: 'back.in',
            onComplete,
        })
    }

    get isVisible(): boolean {
        return this.value === true
    }

    get hasSidebar(): boolean {
        return !!this.$slots.sidebar || !!this.$scopedSlots.sidebar
    }

    closePopOut(): void {
        this.$emit('input', false)
    }

    get outerComponentStyle() {
        return {}
    }

    get innerComponentStyle() {
        return {
            width: this.width,
        }
    }
}
